import { selectXsrfToken } from 'modules/auth/selectors';
import watchProgress from 'model/watchProgress';
import * as auth from 'modules/auth';
import { fetchEvaluationProducts, fetchProductPackagesByKeys } from '../product';
import type { Dispatch } from '../../../../../model/State';
import { CloudProductEvaluationLinks } from '../../../../../data/products/links';

export default async (dispatch: Dispatch) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  if (!xsrfToken) {
    auth.actions.goToLogin();
    return;
  }

  dispatch(fetchProductPackagesByKeys(Object.keys(CloudProductEvaluationLinks)));
  dispatch(fetchEvaluationProducts());
};
